import { useParams } from 'react-router-dom';
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { TwilioRegistrationDetailsPresenter } from './TwilioRegistrationDetailsPresenter';
import { useTwilioMonitorDetail, useRestartFailedStepMutation, useActiveSessions } from '../api';
import { PATHS } from 'src/routes';

export function TwilioRegistrationDetailsContainer() {
  const { id } = useParams<{ id: string }>();
  const { data: twilioRegLog, isLoading } = useTwilioMonitorDetail(id || '');
  const { data: sessions = [], isLoading: isLoadingSessions } = useActiveSessions();
  const { mutate: restartFailedStep, isLoading: isRestarting } = useRestartFailedStepMutation(id || '');

  return (
    <ContentBox>
      <Header
        title="Twilio Registration Details"
        backTo={{
          label: "back to Twilio Monitor",
          path: PATHS.TWILIO_MONITOR
        }}
      />
      <SpinnerWrapper loading={isLoading}>
        <TwilioRegistrationDetailsPresenter
          twilioRegLog={twilioRegLog}
          sessions={sessions}
          isLoadingSessions={isLoadingSessions}
          onRestartFailedStep={(logId: string) =>
            restartFailedStep(logId)
          }
          isRestarting={isRestarting}
        />
      </SpinnerWrapper>
    </ContentBox>
  );
}
